import {
    SET_API_URL,
//    FB_LOGIN_SUCCESS,
    LOGGED_IN,
    LOGGED_OUT,
    SET_SESSION,
    SET_API_LOADING,
    HIDE_SPEEDTEST_INVITATION,
    PASSWORD_RECOVERY,
} from 'constants/ActionTypes';
import {
    SETPROFILE_REQUEST,
    GETPROFILE_SUCCESS,
    GETPROFILE_FAILURE,
    CHECK_EMAIL_REQUEST,
    CHECK_EMAIL_SUCCESS,
    CHECK_EMAIL_FAILURE,
    LOGIN_REQUEST,
    LOGIN_SUCCESS,
    LOGIN_FAILURE,
    REGISTER_FAILURE,
    FB_LOGIN_REQUEST,
    FB_LOGIN_SUCCESS,
    FB_LOGIN_FAILURE,
    LIST_INVOICES_REQUEST,
    LIST_INVOICES_SUCCESS,
    LIST_INVOICES_FAILURE,
    LIST_SERVICES_REQUEST,
    LIST_SERVICES_SUCCESS,
    LIST_SERVICES_FAILURE,
    ACTIVATE_SPEEDTEST_REQUEST,
    ACTIVATE_SPEEDTEST_SUCCESS,
    ACTIVATE_SPEEDTEST_FAILURE,
    DELETE_EMAIL_REQUEST,
    DELETE_EMAIL_SUCCESS,
    DELETE_EMAIL_FAILURE,
    CREATE_EMAIL_REQUEST,
    CREATE_EMAIL_SUCCESS,
    CREATE_EMAIL_FAILURE,
    MODIFY_EMAIL_REQUEST,
    MODIFY_EMAIL_SUCCESS,
    MODIFY_EMAIL_FAILURE,
    SUBSCRIBE_SUPERVECTORING_REQUEST,
    SUBSCRIBE_SUPERVECTORING_SUCCESS,
    SUBSCRIBE_SUPERVECTORING_FAILURE,
    ORDER_SUPERVECTORING_REQUEST,
    ORDER_SUPERVECTORING_SUCCESS,
    ORDER_SUPERVECTORING_FAILURE,
    ORDER_SUPERVECTORING_FIBER_REQUEST,
    ORDER_SUPERVECTORING_FIBER_SUCCESS,
    ORDER_SUPERVECTORING_FIBER_FAILURE,
    SET_IPTV_LICENSES_REQUEST,
    SET_IPTV_LICENSES_SUCCESS,
    SET_IPTV_LICENSES_FAILURE,
    ADD_IPTV_HARDWARE_REQUEST,
    ADD_IPTV_HARDWARE_SUCCESS,
    ADD_IPTV_HARDWARE_FAILURE,
    LOAD_SORTED_CHANNELS_REQUEST,
    LOAD_SORTED_CHANNELS_SUCCESS,
    LOAD_SORTED_CHANNELS_FAILURE,
    SAVE_SORTED_CHANNELS_REQUEST,
    SAVE_SORTED_CHANNELS_SUCCESS,
    SAVE_SORTED_CHANNELS_FAILURE,
    ORDER_FIBER_REQUEST,
    ORDER_FIBER_SUCCESS,
    ORDER_FIBER_FAILURE,
} from 'api/index';

const initialSettings = {
    url: null,
    session: null,
    authenticated: null,
    emailExists: null,
    loginFailure: false,
    isUpdating: false,
    isLoading: false,
    hideSpeedtestInvitation: false,
    passwordRecovery: false,
};

const api = (state = initialSettings, action) => {
    switch (action.type) {
        case PASSWORD_RECOVERY:
            return {
                ...state,
                passwordRecovery: action.payload,
            };
        case HIDE_SPEEDTEST_INVITATION:
            return {
                ...state,
                hideSpeedtestInvitation: true,
            };
        case SET_API_URL:
            return {
                ...state,
                url: action.payload
            };
        case LOAD_SORTED_CHANNELS_REQUEST:
        case SAVE_SORTED_CHANNELS_REQUEST:
        case SETPROFILE_REQUEST:
            return {
                ...state,
                isUpdating: true
            };
        case LOAD_SORTED_CHANNELS_SUCCESS:
        case SAVE_SORTED_CHANNELS_SUCCESS:
        case GETPROFILE_SUCCESS:
            return {
                ...state,
                isUpdating: false
            };
        case LOAD_SORTED_CHANNELS_FAILURE:
        case SAVE_SORTED_CHANNELS_FAILURE:
        case GETPROFILE_FAILURE:
            return {
                ...state,
                isUpdating: false
            };
        case DELETE_EMAIL_REQUEST:
        case CREATE_EMAIL_REQUEST:
        case MODIFY_EMAIL_REQUEST:
        case SUBSCRIBE_SUPERVECTORING_REQUEST:
        case ORDER_SUPERVECTORING_REQUEST:
        case ORDER_SUPERVECTORING_FIBER_REQUEST:
        case ORDER_FIBER_REQUEST:
        case SET_IPTV_LICENSES_REQUEST:
        case ADD_IPTV_HARDWARE_REQUEST:
            return {
                ...state,
                isUpdating: true
            };
        case CREATE_EMAIL_SUCCESS:
        case CREATE_EMAIL_FAILURE:
        case DELETE_EMAIL_SUCCESS:
        case DELETE_EMAIL_FAILURE:
        case MODIFY_EMAIL_SUCCESS:
        case MODIFY_EMAIL_FAILURE:
        case SUBSCRIBE_SUPERVECTORING_SUCCESS:
        case SUBSCRIBE_SUPERVECTORING_FAILURE:
        case ORDER_FIBER_SUCCESS:
        case ORDER_FIBER_FAILURE:
        case ORDER_SUPERVECTORING_SUCCESS:
        case ORDER_SUPERVECTORING_FAILURE:
        case ORDER_SUPERVECTORING_FIBER_SUCCESS:
        case ORDER_SUPERVECTORING_FIBER_FAILURE:
        case SET_IPTV_LICENSES_SUCCESS:
        case SET_IPTV_LICENSES_FAILURE:
        case ADD_IPTV_HARDWARE_SUCCESS:
        case ADD_IPTV_HARDWARE_FAILURE:
            return {
                ...state,
                isUpdating: false
            };
        case LOGGED_IN:
            return {
                ...state,
                session: action.payload.session,
                authenticated: true,
                loginFailure: false,
                fbLoginFailed: false,
                passwordRecovery: null,
            };
        case REGISTER_FAILURE:
        case LOGIN_FAILURE:
            return {
                ...state,
                session: null,
                authenticated: false,
                loginFailure: true,
                fbLoginFailed: false,
                isLoading: false,
            };
        case LOGIN_SUCCESS:
            return {
                ...state,
                isLoading: false,
            };
        case LOGIN_REQUEST:
            return {
                ...state,
                session: null,
                authenticated: false,
                loginFailure: false,
                fbLoginFailed: false,
                isLoading: true,
            };
        case LOGGED_OUT:
            return {
                ...state,
                session: null,
                authenticated: false,
                loginFailure: false,
                fbLoginFailed: false,
                passwordRecovery: null,
            };
        case SET_SESSION:
            return {
                ...state,
                session: action.payload.session,
            };
        case CHECK_EMAIL_REQUEST:
            return {
                ...state,
                emailExists: null,
            };
        case CHECK_EMAIL_SUCCESS:
            return {
                ...state,
                emailExists: true,
            };
        case CHECK_EMAIL_FAILURE:
            return {
                ...state,
                emailExists: false,
            };
        case FB_LOGIN_REQUEST:
            return {
                ...state,
                fbLoginFailed: false,
                loginFailure: false,
                isLoading: true,
            };
        case FB_LOGIN_SUCCESS:
            return {
                ...state,
                fbLoginFailed: false,
                loginFailure: false,
                isLoading: false,
            };
        case FB_LOGIN_FAILURE:
            return {
                ...state,
                fbLoginFailed: true,
                loginFailure: false,
                isLoading: false,
            };
        case LIST_INVOICES_REQUEST:
        case LIST_SERVICES_REQUEST:
            return {
                ...state,
                isLoading: true,
            };
        case LIST_INVOICES_SUCCESS:
        case LIST_INVOICES_FAILURE:
        case LIST_SERVICES_SUCCESS:
        case LIST_SERVICES_FAILURE:
            return {
                ...state,
                isLoading: false,
            };
        case ACTIVATE_SPEEDTEST_REQUEST:
            return {
                ...state,
                isLoading: true,
            };
        case ACTIVATE_SPEEDTEST_SUCCESS:
        case ACTIVATE_SPEEDTEST_FAILURE:
            return {
                ...state,
                isLoading: false,
            };
        case SET_API_LOADING:
            return {
                ...state,
                isLoading: true,
            };
        default:
            return state;
    }
};

export default api;
